export default function FaqSection() {
  const faqs = [
    {
      q: '777影院和7777影院、777777影院、77777影院是什么关系？',
      a: '777影院是官方主站，7777影院、777777影院、77777影院等均为本站的数字变体域名入口。所有变体域名均指向同一官方平台，用户无论通过哪个域名访问，都将进入统一的官方首页，享受相同的影视资源和观影体验。',
    },
    {
      q: '777影院是否需要注册或付费？',
      a: '777影院作为影视导航平台，提供完全免费的影视资源索引和导航服务。用户无需注册账号即可浏览所有推荐内容，点击进入对应影视页面即可开始免费在线观看。我们承诺不设置任何付费墙或会员门槛。',
    },
    {
      q: '网站上的影视资源是否高清？支持哪些清晰度？',
      a: '本站收录的影视资源均以高清画质为标准，主流影片支持1080P及以上清晰度。用户可根据自身网络状况和设备性能，在播放页面自主选择合适的清晰度进行观看，确保流畅体验。',
    },
    {
      q: '为什么有时某些影片无法正常播放？',
      a: '影视资源的可用性受片源方影响，偶尔可能出现个别链接暂时失效的情况。遇到此类问题，建议尝试切换不同的播放线路，或稍后重新访问。我们的运营团队会持续监测资源状态并及时更新维护。',
    },
    {
      q: '手机和平板可以正常访问观看吗？',
      a: '完全可以！777影院采用了全终端响应式设计，无论是电脑、平板还是手机浏览器，都能获得适配的界面和流畅的观影体验。在移动端观看时，我们还特别优化了触控交互和带宽适配。',
    },
    {
      q: '如何确保访问的是777影院官方正站，而非仿冒网站？',
      a: '建议用户收藏本站提供的官方域名（包括7777影院、777777影院、77777影院等数字变体），通过收藏夹直接访问可最大程度避免进入仿冒站点。官方站点界面整洁、无弹窗广告，如遇到强制跳转、要求下载APP或索取个人信息等情况，请立即关闭并核实域名。',
    },
  ];

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于777影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 md:px-6 md:py-5 list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors pr-8">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-primary-500">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5 md:px-6 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}